import styled from "styled-components";

import { windowWidth } from "@styles/global";

// Libraries
import { FormControl } from "@libraries/mui";

const FormContainer = styled.form`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 20px;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  .MuiAutocomplete-root {
    width: 440px;
    min-height: 65px;

    @media (max-width: ${windowWidth.tablet}) {
      width: 100%;
    }
  }
`;

const SelectItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;

  > :first-child {
    div {
      width: 22px;
      height: 22px;
    }
  }
`;

const CustomFormControl = styled(FormControl)`
  width: 0px !important;
`;

/**
 * Visual indicator shown when the selected contract has no pump types
 * registered, signalling that the default fallback options are in use.
 */
const FallbackNotice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 440px;
  margin-bottom: 8px;
  padding: 6px 10px;
  border-radius: 4px;
  background-color: rgba(255, 167, 38, 0.12);
  border: 1px solid rgba(255, 167, 38, 0.5);
  color: #b26a00;
  font-size: 0.78rem;
  line-height: 1.2;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;
  }
`;

export {
  FormContainer,
  CustomFormControl,
  SelectItem,
  FallbackNotice
};
